// Source of truth: commercial/cl-data/Repositories/FakeDataRepository.cs
// When the C# repository changes, hand-port the diff here.
//
// TODO: Replace this hand-port with a PL portal-API endpoint that reads
// FakeDataRepository directly (matching CL's /fakeDataSets pattern). Blocked
// until pl-portal-api is upgraded from net6.0 to net8.0 — IQ.Tools targets
// net8.0 and can't be referenced from a net6.0 project.

export interface FakeAddress {
  State: string;
  Address: string;
  Markets: string[];
}

export interface FakeDataSet {
  ProductType: string;
  Addresses: FakeAddress[];
}

export const fakeAddressPool: FakeDataSet[] = [
  {
    "ProductType": "homeowners",
    "Addresses": [
      {
        "State": "AL",
        "Address": "7157 Rowan Rd, Leeds, AL 35094, Jefferson County",
        "Markets": [
          "VavePersonalLines"
        ]
      },
      {
        "State": "AL",
        "Address": "150 Ruth Estates Dr, Atmore, AL 36502, Escambia County",
        "Markets": [
          "VavePersonalLines"
        ]
      },
      {
        "State": "CT",
        "Address": "595 Norwich Rd, Salem, CT 06420, New London County",
        "Markets": [
          "VavePersonalLines"
        ]
      },
      {
        "State": "CT",
        "Address": "59 Water St, Southington, CT 06489, Hartford County",
        "Markets": [
          "VavePersonalLines"
        ]
      },
      {
        "State": "FL",
        "Address": "1870 Scenic Gulf Dr, Miramar Beach, FL 32550, Walton County",
        "Markets": [
          "VavePersonalLines",
          "AccessAlpha",
          "Munich"
        ]
      },
      {
        "State": "FL",
        "Address": "5807 NW 12th Ct, Bell, FL 32619, Gilchrist County",
        "Markets": [
          "VavePersonalLines"
        ]
      },
      {
        "State": "FL",
        "Address": "589 Coconut St, Satellite Beach, FL 32937, Brevard County",
        "Markets": [
          "VavePersonalLines"
        ]
      },
      {
        "State": "GA",
        "Address": "768 Crestridge Dr NE, Atlanta, GA 30306, Fulton County",
        "Markets": [
          "VavePersonalLines"
        ]
      },
      {
        "State": "MD",
        "Address": "3008 Arapaho Ct, Westminster, MD 21157, Carroll County",
        "Markets": [
          "AccessAlpha"
        ]
      },
      {
        "State": "MT",
        "Address": "108 4th St, Deer Lodge, MT 59722, Powell County",
        "Markets": [
          "AccessAlpha"
        ]
      },
      {
        "State": "MT",
        "Address": "1830 Snowmass Dr, Seeley Lake, MT 59868, Missoula County",
        "Markets": [
          "AccessAlpha"
        ]
      },
      {
        "State": "NC",
        "Address": "4009 High Mountain Dr, Raleigh, NC 27603, Wake County",
        "Markets": [
          "VavePersonalLines",
          "AccessAlpha",
          "Munich"
        ]
      },
      {
        "State": "NC",
        "Address": "1905 Ashland Ave, Charlotte, NC 28205, Mecklenburg County",
        "Markets": [
          "VavePersonalLines",
          "AccessAlpha",
          "Munich"
        ]
      },
      {
        "State": "ND",
        "Address": "4505 47th St N, Fargo, ND 58102, Cass County",
        "Markets": [
          "VavePersonalLines"
        ]
      },
      {
        "State": "TX",
        "Address": "1847 Candlelight Place Dr, Houston, TX 77018, Harris County",
        "Markets": [
          "VavePersonalLines",
          "AccessAlpha",
          "Munich"
        ]
      },
      {
        "State": "VA",
        "Address": "2501 Stuart Pl, Falls Church, VA 22046, Fairfax County",
        "Markets": [
          "VavePersonalLines"
        ]
      }
    ]
  },
  {
    "ProductType": "flood",
    "Addresses": [
      {
        "State": "CO",
        "Address": "1010 N 10th St, Ca�on City, CO 81212, Fremont County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "CT",
        "Address": "166 Lake St, Manchester, CT 06040, Hartford County",
        "Markets": [
          "Chubb",
          "BHSI"
        ]
      },
      {
        "State": "GA",
        "Address": "1235 Kennestone Cir, Marietta, GA 30066, Cobb County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "GA",
        "Address": "4021 Melvin Dr, Atlanta, GA 30331, Fulton County",
        "Markets": [
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "MA",
        "Address": "7 Allendale Ave, Billerica, MA 01821, Middlesex County",
        "Markets": [
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "NC",
        "Address": "4009 High Mountain Dr, Raleigh, NC 27603, Wake County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "NC",
        "Address": "1803 Country Club Rd, Lincolnton, NC 28092, Lincoln County",
        "Markets": [
          "BHSI"
        ]
      },
      {
        "State": "NC",
        "Address": "595 George Sherman Rd, Rougemont, NC 27572, Person County",
        "Markets": [
          "AccessAlphaFlood"
        ]
      },
      {
        "State": "TX",
        "Address": "6215 Misty Wood Dr, Dallas, TX 75217, Dallas County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "TX",
        "Address": "13808 TX-206, Coleman, TX 76834, Coleman County",
        "Markets": [
          "Chubb"
        ]
      },
      {
        "State": "TX",
        "Address": "1410 Adelaide Dr, Dallas, TX 75216, Dallas County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "AL",
        "Address": "1372 Sandy Ln, Gulf Shores, AL 36542, Baldwin County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "AL",
        "Address": "1470 Sierra St, Montgomery, AL 36108, Montgomery County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "AL",
        "Address": "120 2nd St NE, Aliceville, AL 35442, Pickens County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "AR",
        "Address": "124 N Hazel St, North Little Rock, AR 72114, Pulaski County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "AZ",
        "Address": "819 W Elna Rae St, Tempe, AZ 85281, Maricopa County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "CA",
        "Address": "1336 Q St, Newman, CA 95360, Stanislaus County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "CO",
        "Address": "2595 S Lowell Blvd, Denver, CO 80219, Denver County",
        "Markets": [
          "Vave",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "CT",
        "Address": "192 Reed St, Stratford, CT 06614, Fairfield County",
        "Markets": [
          "Vave",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "CT",
        "Address": "989 Fairfield Beach Rd, Fairfield, CT 06824, Fairfield County",
        "Markets": [
          "Vave",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "DC",
        "Address": "630 East Capitol St NE, Washington, DC 20003, District of Columbia",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "DE",
        "Address": "206 Lakeview Ave, Milford, DE 19963, Sussex County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "DE",
        "Address": "539 N West St, Dover, DE 19904, Kent County",
        "Markets": [
          "Vave",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "FL",
        "Address": "1605 Sand Castle Rd, Sanibel, FL 33957, Lee County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "FL",
        "Address": "432 Seaworthy Rd, North Fort Myers, FL 33903, Lee County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "FL",
        "Address": "1752 Valley Forge St, Orlando, FL 32806, Orange County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "GA",
        "Address": "616 Broadway, Columbus, GA 31901, Muscogee County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "IA",
        "Address": "623 Virginia Ave, Des Moines, IA 50315, Polk County",
        "Markets": [
          "Vave",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "ID",
        "Address": "1563 E Holly St, Boise, ID 83712, Ada County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "IL",
        "Address": "2617 S Sawyer Ave, Chicago, IL 60623, Cook County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "IN",
        "Address": "1404 Lexington Ave, Indianapolis, IN 46203, Marion County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "KS",
        "Address": "830 Osage St, Manhattan, KS 66502, Riley County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "LA",
        "Address": "276 Prospect St, Shreveport, LA 71104, Caddo Parish",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "MA",
        "Address": "112 Harrishof St, Boston, MA 02121, Suffolk County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "MD",
        "Address": "7304 E Springbrook Ct, Middletown, MD 21769, Frederick County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "MD",
        "Address": "1112 Edmondson Ave, Catonsville, MD 21228, Baltimore County",
        "Markets": [
          "Vave",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "ME",
        "Address": "12 Libby St, Scarborough, ME 04074, Cumberland County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "MN",
        "Address": "1206 Washington St NE, Minneapolis, MN 55413, Hennepin County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "MI",
        "Address": "2704 W Holmes Rd, Lansing, MI 48911, Ingham County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "MO",
        "Address": "3906 S Benton Ave, Kansas City, MO 64130, Jackson County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "MO",
        "Address": "2116 Jannette Dr, St Louis, MO 63136, St. Louis County",
        "Markets": [
          "Vave",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "MS",
        "Address": "325 Broad St, Jackson, MS 39203, Hinds County",
        "Markets": [
          "Vave",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "MT",
        "Address": "514 6th Ave N, Lewistown, MT 59457, Fergus County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "NC",
        "Address": "4123 Carmel Forest Dr, Charlotte, NC 28226, Mecklenburg County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "ND",
        "Address": "1548 Oakland Dr, Bismarck, ND 58504, Burleigh County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "NE",
        "Address": "2330 S 34th St, Omaha, NE 68105, Douglas County",
        "Markets": [
          "Vave",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "NE",
        "Address": "940 S 32nd St, Lincoln, NE 68510, Lancaster County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "NH",
        "Address": "353 Central St, Manchester, NH 03103, Hillsborough County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "NJ",
        "Address": "169 Veterans Drive, Northvale, NJ 07647, Bergen County",
        "Markets": [
          "Vave",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "NJ",
        "Address": "122 N Wyoming Ave, Ventnor City, NJ 08406, Atlantic County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "NJ",
        "Address": "910 N Indiana Ave, Atlantic City, NJ 08401, Atlantic County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "NJ",
        "Address": "112 E 10th Ave, North Wildwood, NJ 08260, Cape May County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "NJ",
        "Address": "6007 Winchester Ave, Ventnor City, NJ 08406, Atlantic County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "NM",
        "Address": "4116 Avenida La Resolana NE, Albuquerque, NM 87110, Bernalillo County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "NV",
        "Address": "355 E Larson Ln, Henderson, NV 89015, Clark County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "OH",
        "Address": "3651 Herbert Ave, Cincinnati, OH 45211, Hamilton County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "OH",
        "Address": "1101 Blennerhassett Ave, Belpre, OH 45714, Washington County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "OK",
        "Address": "502 E Eufaula St, Norman, OK 73071, Cleveland County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "OR",
        "Address": "6820 SE 64th Ave, Portland, OR 97206, Multnomah County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "PA",
        "Address": "432 Ice Harvest Dr, Mountain Top, PA 18707, Luzerne County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "RI",
        "Address": "45 Watson Ave, Narragansett, RI 02882, Washington County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "SC",
        "Address": "101 Scottswood Dr, Spartanburg, SC 29302, Spartanburg County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "SC",
        "Address": "978 Carmel Dr, Charleston, SC 29412, Charleston County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "SC",
        "Address": "3184 State Rd 26-816, Murrells Inlet, SC 29576, Horry County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "SD",
        "Address": "901 S Hawthorne Ave, Sioux Falls, SD 57104, Minnehaha County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "TN",
        "Address": "305 Brentwood Pkwy, Brentwood, TN 37027, Williamson County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "TX",
        "Address": "2911 Sandpiper St, Humble, TX 77396, Harris County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "TX",
        "Address": "111 Avery Springs Ln, Dickinson, TX 77539, Galveston County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "TX",
        "Address": "18722 Ponte Mazzotta Ln, New Caney, TX 77357, Montgomery County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "TX",
        "Address": "1104 E 24th St, Houston, TX 77009, Harris County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "TX",
        "Address": "17315 E Lake Rose Ct, Cypress, TX 77429, Harris County",
        "Markets": [
          "Vave",
          "Chubb",
          "Hiscox"
        ]
      },
      {
        "State": "UT",
        "Address": "467 100 S, Provo, UT 84601, Utah County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood",
          "Chubb",
          "BHSI",
          "Hiscox"
        ]
      },
      {
        "State": "VA",
        "Address": "8528 Hazen St, Richmond, VA 23235, Chesterfield County",
        "Markets": [
          "Vave",
          "AccessAlphaFlood"
        ]
      }
    ]
  },
  {
    "ProductType": "fallback",
    "Addresses": [
      {
        "State": "AK",
        "Address": "941 21st Ave, Fairbanks, AK 99701, Fairbanks North Star Borough",
        "Markets": []
      },
      {
        "State": "AK",
        "Address": "328 Distin Ave, Juneau, AK 99801, Juneau City and Borough",
        "Markets": []
      },
      {
        "State": "HI",
        "Address": "558 Paihi St, Aiea, HI 96701, Honolulu County",
        "Markets": []
      },
      {
        "State": "HI",
        "Address": "612 Aliipoe Dr, Aiea, HI 96701, Honolulu County",
        "Markets": []
      },
      {
        "State": "KY",
        "Address": "1955 Deer Park Ave, Louisville, KY 40205, Jefferson County",
        "Markets": []
      },
      {
        "State": "KY",
        "Address": "1807 Strand Ave, Louisville, KY 40205, Jefferson County",
        "Markets": []
      },
      {
        "State": "NY",
        "Address": "48 Unger Ave, Buffalo, NY 14210, Erie County",
        "Markets": []
      },
      {
        "State": "NY",
        "Address": "146 W Elmview Ave, Buffalo, NY 14218, Erie County",
        "Markets": []
      },
      {
        "State": "VT",
        "Address": "12 Park Ave, Montpelier, VT 05602, Washington County",
        "Markets": []
      },
      {
        "State": "VT",
        "Address": "9 Sabin St, Montpelier, VT 05602, Washington County",
        "Markets": []
      },
      {
        "State": "WA",
        "Address": "20034 Woden Ct NE, Poulsbo, WA 98370, Kitsap County",
        "Markets": []
      },
      {
        "State": "WA",
        "Address": "2447 NE Sunnymede St, Poulsbo, WA 98370, Kitsap County",
        "Markets": []
      },
      {
        "State": "WV",
        "Address": "1804 11th Ave, Huntington, WV 25701, Cabell County",
        "Markets": []
      },
      {
        "State": "WV",
        "Address": "1142 Madison Ave, Huntington, WV 25704, Cabell County",
        "Markets": []
      },
      {
        "State": "WI",
        "Address": "7222 Tempe Dr, Madison, WI 53719, Dane County",
        "Markets": []
      },
      {
        "State": "WI",
        "Address": "4141 Nakoma Rd, Madison, WI 53711, Dane County",
        "Markets": []
      },
      {
        "State": "AL",
        "Address": "120 15th St E Apt 4103, Tuscaloosa, AL 35401, Tuscaloosa County",
        "Markets": []
      },
      {
        "State": "AL",
        "Address": "1306 14th Ave SE, Decatur, AL 35601, Morgan County",
        "Markets": []
      },
      {
        "State": "AK",
        "Address": "2801 Debarr Rd, Anchorage, AK 99508, Anchorage Municipality",
        "Markets": []
      },
      {
        "State": "AK",
        "Address": "5831 Grand Teton Loop, Anchorage, AK 99502, Anchorage Municipality",
        "Markets": []
      },
      {
        "State": "AZ",
        "Address": "3931 E Delta Cir, Mesa, AZ 85206, Maricopa County",
        "Markets": []
      },
      {
        "State": "AZ",
        "Address": "3946 E Remington Dr, Gilbert, AZ 85297, Maricopa County",
        "Markets": []
      },
      {
        "State": "AR",
        "Address": "174 Pinto Ln, Hot Springs, AR 71913, Garland County",
        "Markets": []
      },
      {
        "State": "AR",
        "Address": "500 Krewson St, Jonesboro, AR 72401, Craighead County",
        "Markets": []
      },
      {
        "State": "CA",
        "Address": "1183 Nimitz Dr, Daly City, CA 94015, San Mateo County",
        "Markets": []
      },
      {
        "State": "CA",
        "Address": "1474 Hillsdale Ave, San Jose, CA 95118, Santa Clara County",
        "Markets": []
      },
      {
        "State": "CO",
        "Address": "4657 S Wolff St, Denver, CO 80236, Denver County",
        "Markets": []
      },
      {
        "State": "CO",
        "Address": "1801 W 21st St, Pueblo, CO 81003, Pueblo County",
        "Markets": []
      },
      {
        "State": "CT",
        "Address": "1485 Dunbar Hill Rd, Hamden, CT 06514, New Haven County",
        "Markets": []
      },
      {
        "State": "CT",
        "Address": "33 Hoffman Rd, Ellington, CT 06029, Tolland County",
        "Markets": []
      },
      {
        "State": "DE",
        "Address": "1411 Brook Ln, Wilmington, DE 19805, New Castle County",
        "Markets": []
      },
      {
        "State": "DE",
        "Address": "25917 River Bend Rd # Ut504, Millsboro, DE 19966, Sussex County",
        "Markets": []
      },
      {
        "State": "FL",
        "Address": "11353 Camus Ln, Orlando, FL 32824, Orange County",
        "Markets": []
      },
      {
        "State": "FL",
        "Address": "11470 SW Lake Park Dr, Port St Lucie, FL 34987, St. Lucie County",
        "Markets": []
      },
      {
        "State": "GA",
        "Address": "104 Morningside Dr, Carrollton, GA 30117, Carroll County",
        "Markets": []
      },
      {
        "State": "GA",
        "Address": "1706 Valley Park Ct Apt D, Augusta, GA 30909, Richmond County",
        "Markets": []
      },
      {
        "State": "HI",
        "Address": "91-1101 Koanimakani St, Kapolei, HI 96707, Honolulu County",
        "Markets": []
      },
      {
        "State": "HI",
        "Address": "1440 Cromwell Cir Unit 33, Jbphh, HI 96860, Honolulu County",
        "Markets": []
      },
      {
        "State": "ID",
        "Address": "309 N 4300 E, Rigby, ID 83442, Jefferson County",
        "Markets": []
      },
      {
        "State": "ID",
        "Address": "90 Park Ln, Sandpoint, ID 83864, Bonner County",
        "Markets": []
      },
      {
        "State": "IL",
        "Address": "1312 Franciscan Way, Joliet, IL 60435, Will County",
        "Markets": []
      },
      {
        "State": "IL",
        "Address": "124 W Kennedy Dr, Streamwood, IL 60107, Cook County",
        "Markets": []
      },
      {
        "State": "IN",
        "Address": "2430 W 3rd St Apt 32, Bloomington, IN 47404, Monroe County",
        "Markets": []
      },
      {
        "State": "IN",
        "Address": "12409 W 105th Cir, Saint John, IN 46373, Lake County",
        "Markets": []
      },
      {
        "State": "IA",
        "Address": "106 E Main St, Spragueville, IA 52074, Jackson County",
        "Markets": []
      },
      {
        "State": "IA",
        "Address": "227 NW Pike Cir, Waukee, IA 50263, Dallas County",
        "Markets": []
      },
      {
        "State": "KS",
        "Address": "14608 Dearborn St, Overland Park, KS 66223, Johnson County",
        "Markets": []
      },
      {
        "State": "KS",
        "Address": "24941 W 143rd Ter, Olathe, KS 66061, Johnson County",
        "Markets": []
      },
      {
        "State": "KY",
        "Address": "14403 Estate Ridge Blvd, Louisville, KY 40291, Jefferson County",
        "Markets": []
      },
      {
        "State": "KY",
        "Address": "105 Dublin Ln, Shelbyville, KY 40065, Shelby County",
        "Markets": []
      },
      {
        "State": "LA",
        "Address": "104 Ashland Dr, Houma, LA 70363, Terrebonne Parish",
        "Markets": []
      },
      {
        "State": "LA",
        "Address": "108 Oak Moss Dr, La Place, LA 70068, St. John the Baptist Parish",
        "Markets": []
      },
      {
        "State": "ME",
        "Address": "18 Forest Ter, Brunswick, ME 04011, Cumberland County",
        "Markets": []
      },
      {
        "State": "ME",
        "Address": "2 Ames Ln, Jefferson, ME 04348, Lincoln County",
        "Markets": []
      },
      {
        "State": "MD",
        "Address": "2658 Lehman St, Baltimore, MD 21223, Baltimore City",
        "Markets": []
      },
      {
        "State": "MD",
        "Address": "1880 Disney Estates Cir, Severn, MD 21144, Anne Arundel County",
        "Markets": []
      },
      {
        "State": "MA",
        "Address": "18 Fairway Dr, Topsfield, MA 01983, Essex County",
        "Markets": []
      },
      {
        "State": "MA",
        "Address": "2 Pinewood Dr, Marion, MA 02738, Plymouth County",
        "Markets": []
      },
      {
        "State": "MI",
        "Address": "1744 Briarwood Dr, Lansing, MI 48917, Ingham County",
        "Markets": []
      },
      {
        "State": "MI",
        "Address": "1257 Hudson St SW, Wyoming, MI 49509, Kent County",
        "Markets": []
      },
      {
        "State": "MN",
        "Address": "22308 Gateway Dr, Osakis, MN 56360, Douglas County",
        "Markets": []
      },
      {
        "State": "MN",
        "Address": "1260 Shryer Ave W, Saint Paul, MN 55113, Ramsey County",
        "Markets": []
      },
      {
        "State": "MS",
        "Address": "1817 Shelby Ln, Ocean Springs, MS 39564, Jackson County",
        "Markets": []
      },
      {
        "State": "MS",
        "Address": "144 Old Highway 98 E, Columbia, MS 39429, Marion County",
        "Markets": []
      },
      {
        "State": "MO",
        "Address": "186 W Hickory Ridge Rd, Steelville, MO 65565, Crawford County",
        "Markets": []
      },
      {
        "State": "MO",
        "Address": "2002 Chateau Dr Apt D, Harrisonville, MO 64701, Cass County",
        "Markets": []
      },
      {
        "State": "MT",
        "Address": "650 Macgregor Rd, Belgrade, MT 59714, Gallatin County",
        "Markets": []
      },
      {
        "State": "MT",
        "Address": "PO Box 113, Livingston, MT 59047, Park County",
        "Markets": []
      },
      {
        "State": "NE",
        "Address": "1816 N 75th Ave, Omaha, NE 68114, Douglas County",
        "Markets": []
      },
      {
        "State": "NE",
        "Address": "3711 W St, Omaha, NE 68107, Douglas County",
        "Markets": []
      },
      {
        "State": "NV",
        "Address": "6648 Johnny Love Ln, N Las Vegas, NV 89086, Clark County",
        "Markets": []
      },
      {
        "State": "NV",
        "Address": "3101 Highland Falls Dr, Las Vegas, NV 89134, Clark County",
        "Markets": []
      },
      {
        "State": "NH",
        "Address": "5 Scarborough Dr, Nashua, NH 03063, Hillsborough County",
        "Markets": []
      },
      {
        "State": "NH",
        "Address": "97 Cannongate III, Nashua, NH 03063, Hillsborough County",
        "Markets": []
      },
      {
        "State": "NJ",
        "Address": "101 Flatbrook Rd, Branchville, NJ 07826, Sussex County",
        "Markets": []
      },
      {
        "State": "NJ",
        "Address": "117 Hiawatha Blvd, Oakland, NJ 07436, Bergen County",
        "Markets": []
      },
      {
        "State": "NM",
        "Address": "2412 Northglen Dr, Clovis, NM 88101, Curry County",
        "Markets": []
      },
      {
        "State": "NM",
        "Address": "202 Cromwell Ave SW, Albuquerque, NM 87102, Bernalillo County",
        "Markets": []
      },
      {
        "State": "NY",
        "Address": "1184 Louise Way, Victor, NY 14564, Ontario County",
        "Markets": []
      },
      {
        "State": "NY",
        "Address": "11931 199th St, Saint Albans, NY 11412, Queens County",
        "Markets": []
      },
      {
        "State": "NC",
        "Address": "15804 Glen Miro Dr, Huntersville, NC 28078, Mecklenburg County",
        "Markets": []
      },
      {
        "State": "NC",
        "Address": "109 Thornehille Dr, State Road, NC 28676, Surry County",
        "Markets": []
      },
      {
        "State": "ND",
        "Address": "1466 13th St N, Wahpeton, ND 58075, Richland County",
        "Markets": []
      },
      {
        "State": "ND",
        "Address": "1431 4th St N, Wahpeton, ND 58075, Richland County",
        "Markets": []
      },
      {
        "State": "OH",
        "Address": "158 Somerset Rd, Delaware, OH 43015, Delaware County",
        "Markets": []
      },
      {
        "State": "OH",
        "Address": "1020 Windsor St, Cincinnati, OH 45206, Hamilton County",
        "Markets": []
      },
      {
        "State": "OK",
        "Address": "502 W Cummings St, Henryetta, OK 74437, Okmulgee County",
        "Markets": []
      },
      {
        "State": "OK",
        "Address": "2004 Alliyah Ct, Yukon, OK 73099, Canadian County",
        "Markets": []
      },
      {
        "State": "OR",
        "Address": "40100 Mountain Home Dr, Sweet Home, OR 97386, Linn County",
        "Markets": []
      },
      {
        "State": "OR",
        "Address": "2250 Lansing Ave NE, Salem, OR 97301, Marion County",
        "Markets": []
      },
      {
        "State": "PA",
        "Address": "103 Searle St, Pittston, PA 18640, Luzerne County",
        "Markets": []
      },
      {
        "State": "PA",
        "Address": "141 Martins Corner Rd, Coatesville, PA 19320, Chester County",
        "Markets": []
      },
      {
        "State": "RI",
        "Address": "85 East Ave, Westerly, RI 02891, Washington County",
        "Markets": []
      },
      {
        "State": "RI",
        "Address": "49 Mathewson Rd, Barrington, RI 02806, Bristol County",
        "Markets": []
      },
      {
        "State": "SC",
        "Address": "103 Chipping Ct, Greer, SC 29650, Greenville County",
        "Markets": []
      },
      {
        "State": "SC",
        "Address": "12 Meadow Mist Trl, Greer, SC 29650, Greenville County",
        "Markets": []
      },
      {
        "State": "SD",
        "Address": "3053 Willowbend Rd, Rapid City, SD 57703, Pennington County",
        "Markets": []
      },
      {
        "State": "SD",
        "Address": "27317 472nd Ave, Harrisburg, SD 57032, Lincoln County",
        "Markets": []
      },
      {
        "State": "TN",
        "Address": "1646 Neelys Bend Rd, Madison, TN 37115, Davidson County",
        "Markets": []
      },
      {
        "State": "TN",
        "Address": "1504 Bellafonte Ct, Nashville, TN 37221, Davidson County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1122 Jackson St Apt 810, Dallas, TX 75202, Dallas County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "102 Cynthia Ln, Weatherford, TX 76087, Parker County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "101 Chestnut St, Kirbyville, TX 75956, Jasper County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "11741 County Rd E, Pampa, TX 79065, Gray County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1161 Lynn Creek Rd, Jacksboro, TX 76458, Jack County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "113 McBride Ln, Cedar Park, TX 78613, Williamson County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "114 Alexander Hamilton Dr, San Antonio, TX 78228, Bexar County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "110 Avenue O, Lamesa, TX 79331, Dawson County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "10002 Hidden Acres Dr, Cleveland, TX 77328, Liberty County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "10564 State Highway 7 E, Centerville, TX 75833, Leon County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "115 Yellowstone Lake Dr, Laredo, TX 78041, Webb County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "11803 Turtle Gate Dr, Houston, TX 77070, Harris County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "10655 Memorial Dr, Houston, TX 77024, Harris County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1089 Fm 1950, Chilton, TX 76632, Falls County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "101 Modene St, Seagoville, TX 75159, Dallas County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1139 E 19th St, San Angelo, TX 76903, Tom Green County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "108 Stratton Ln, Jarrell, TX 76537, Williamson County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "11705 Henry Phipps Dr, El Paso, TX 79936, El Paso County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1 Bayou Bend Pl, Beaumont, TX 77706, Jefferson County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1003 W Victoria St, Brady, TX 76825, McCulloch County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "103 Robindale Cir, Conroe, TX 77384, Montgomery County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "105 Cheyenne Trl, Gilmer, TX 75644, Upshur County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1016 Dawn Ct, Granbury, TX 76048, Hood County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "107 Apache Dr, Greenville, TX 75402, Hunt County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "118 Cedar Valley Ln, Cedar Hill, TX 75104, Dallas County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "11 April Vlg, Montgomery, TX 77356, Montgomery County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "12045 S Highway 281, Santo, TX 76472, Palo Pinto County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "10924 Lane St, Houston, TX 77029, Harris County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "11120 Borrado Dr, Laredo, TX 78045, Webb County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1148 Browntop St, Crowley, TX 76036, Tarrant County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1117 Haye Rd, Friendswood, TX 77546, Galveston County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "10304 Waterbury Dr, Dallas, TX 75217, Dallas County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "112 Horseshoe Dr, Cooper, TX 75432, Delta County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "10338 Cottontail Ln, San Angelo, TX 76901, Tom Green County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1136 Eagle Ridge Dr, El Paso, TX 79912, El Paso County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1006 Mexico St, Edna, TX 77957, Jackson County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1003 Nathan Ln, Copperas Cove, TX 76522, Coryell County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1012 1/2 Jackson St N, Sulphur Spgs, TX 75482, Hopkins County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1122 San Miguel Dr, Duncanville, TX 75137, Dallas County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "10223 Copperdale Ln, Houston, TX 77064, Harris County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1096 James Dr, Kaufman, TX 75142, Kaufman County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "109 Mill Xing E, Colleyville, TX 76034, Tarrant County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "10223 China Tree Dr, Dallas, TX 75249, Dallas County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1111 Giverny Ct, Spring, TX 77379, Harris County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "11533 Fm 2258, Grandview, TX 76050, Johnson County",
        "Markets": []
      },
      {
        "State": "TX",
        "Address": "1103 Johnson Ave, Palacios, TX 77465, Matagorda County",
        "Markets": []
      },
      {
        "State": "UT",
        "Address": "8063 S 2525 E, Ogden, UT 84405, Weber County",
        "Markets": []
      },
      {
        "State": "UT",
        "Address": "894 E Lazon Dr, Sandy, UT 84094, Salt Lake County",
        "Markets": []
      },
      {
        "State": "UT",
        "Address": "1326 W American Ave, Salt Lake Cty, UT 84104, Salt Lake County",
        "Markets": []
      },
      {
        "State": "VT",
        "Address": "281 Eastview Cir, Williston, VT 05495, Chittenden County",
        "Markets": []
      },
      {
        "State": "VA",
        "Address": "104 Riverside Dr, Waynesboro, VA 22980, Waynesboro City",
        "Markets": []
      },
      {
        "State": "VA",
        "Address": "1645 Fadley Rd, Weyers Cave, VA 24486, Augusta County",
        "Markets": []
      },
      {
        "State": "WA",
        "Address": "10503 NE 99th Ave, Vancouver, WA 98662, Clark County",
        "Markets": []
      },
      {
        "State": "WA",
        "Address": "12890 SE Game Trail Way, Port Orchard, WA 98367, Kitsap County",
        "Markets": []
      },
      {
        "State": "WV",
        "Address": "472 Hill St, Madison, WV 25130, Boone County",
        "Markets": []
      },
      {
        "State": "WV",
        "Address": "312 Greenbrier Hl, Marlinton, WV 24954, Pocahontas County",
        "Markets": []
      },
      {
        "State": "WI",
        "Address": "2920 N 78th St, Milwaukee, WI 53222, Milwaukee County",
        "Markets": []
      },
      {
        "State": "WI",
        "Address": "10811 Country Club Ln, Hayward, WI 54843, Sawyer County",
        "Markets": []
      },
      {
        "State": "WY",
        "Address": "4110 Grizzly, Casper, WY 82604, Natrona County",
        "Markets": []
      },
      {
        "State": "WY",
        "Address": "1100 Prairie Ave, Cheyenne, WY 82009, Laramie County",
        "Markets": []
      }
    ]
  }
];
